<template>
    <svg id="Maps-Layers-Landowner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
            v-if="!state && !upgrade"
            id="Outlined"
            d="M12,20.67c-.1,0-.19-.03-.28-.08L.22,12.92c-.23-.15-.29-.46-.14-.69.15-.23.47-.29.69-.14l11.22,7.48,11.22-7.48c.23-.15.54-.09.69.14.15.23.09.54-.14.69l-11.5,7.67c-.08.06-.18.08-.28.08ZM12,24c-.1,0-.19-.03-.28-.08L.22,16.25c-.23-.15-.29-.46-.14-.69.15-.23.47-.29.69-.14l11.22,7.48,11.22-7.48c.23-.15.54-.09.69.14.15.23.09.54-.14.69l-11.5,7.67c-.08.06-.18.08-.28.08ZM10,11.5c0-.28.22-.5.5-.5h3c.28,0,.5.22.5.5v3.13c0,.2.22.32.39.21l9.39-6.26c.14-.09.22-.25.22-.42s-.08-.32-.22-.42L12.28.08c-.17-.11-.39-.11-.55,0L.22,7.75C.08,7.84,0,8,0,8.17s.08.32.22.42l9.39,6.26c.17.11.39,0,.39-.21v-3.13ZM10.5,8.5c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5-.67,1.5-1.5,1.5-1.5-.67-1.5-1.5ZM17,11.9v-2.11h1c.21,0,.4-.13.47-.33s.01-.42-.15-.55l-1.32-1.12v-1.79c0-.28-.22-.5-.5-.5h-1c-.28,0-.5.22-.5.5v.1l-2.08-1.76c-.53-.45-1.31-.45-1.84,0l-5.4,4.57c-.16.14-.22.36-.15.55s.26.33.47.33h1v2.11l-5.6-3.73L12,1.1l10.6,7.07-5.6,3.73Z"
        />
        <path
            v-if="state"
            id="Filled"
            d="M12.28,20.58l11.5-7.67c.23-.15.29-.46.14-.69-.15-.23-.47-.29-.69-.14l-11.22,7.48L.78,12.08c-.23-.15-.54-.09-.69.14-.15.23-.09.54.14.69l11.5,7.67c.08.06.18.08.28.08s.19-.03.28-.08ZM12.28,23.92l11.5-7.67c.23-.15.29-.46.14-.69-.15-.23-.47-.29-.69-.14l-11.22,7.48L.78,15.42c-.23-.15-.54-.09-.69.14-.15.23-.09.54.14.69l11.5,7.67c.08.06.18.08.28.08s.19-.03.28-.08ZM14,11.5v3.6l-1.72,1.15c-.08.06-.18.08-.28.08s-.19-.03-.28-.08l-1.72-1.15v-3.6c0-.28.22-.5.5-.5h3c.28,0,.5.22.5.5ZM12,7c-.83,0-1.5.67-1.5,1.5s.67,1.5,1.5,1.5,1.5-.67,1.5-1.5-.67-1.5-1.5-1.5ZM24,8.17c0-.17-.08-.32-.22-.42L12.28.08c-.17-.11-.39-.11-.55,0L.22,7.75C.08,7.84,0,8,0,8.17s.08.32.22.42l6.78,4.52v-3.31h-1c-.21,0-.4-.13-.47-.33s-.01-.42.15-.55l5.4-4.57c.53-.45,1.31-.45,1.84,0l2.08,1.76v-.1c0-.28.22-.5.5-.5h1c.28,0,.5.22.5.5v1.79l1.32,1.12c.16.14.22.36.15.55s-.26.33-.47.33h-1v3.31l6.78-4.52c.14-.09.22-.25.22-.42Z"
        />
        <g v-if="painted || upgrade || paint" id="Painted">
            <path
                id="Body"
                d="M12,20.67c-.1,0-.19-.03-.28-.08L.22,12.92c-.23-.15-.29-.46-.14-.69s.47-.29.69-.14l11.22,7.48,11.22-7.48c.23-.15.54-.09.69.14.15.23.09.54-.14.69l-11.5,7.67c-.08.06-.18.08-.28.08ZM12.28,23.92l11.5-7.67c.23-.15.29-.46.14-.69-.15-.23-.47-.29-.69-.14l-11.22,7.48L.78,15.42c-.23-.15-.54-.09-.69.14-.15.23-.09.54.14.69l11.5,7.67c.08.06.18.08.28.08s.19-.03.28-.08Z"
            />
            <path
                v-if="!upgrade"
                id="Paintme"
                :fill="paint"
                d="M23.78,7.75L12.28.08c-.17-.11-.39-.11-.55,0L.22,7.75C.08,7.84,0,8,0,8.17v1c0,.17.08.32.22.42l11.5,7.67c.08.06.18.08.28.08s.19-.03.28-.08l11.5-7.67c.14-.09.22-.25.22-.42v-1c0-.17-.08-.32-.22-.42Z"
            />
            <path
                v-if="upgrade"
                id="Paintme"
                d="M19 10.502c-1.76 0-3.22-1.31-3.46-3h-1.31c-.67 0-1.29-.4-1.57-1.02-.29-.64-.18-1.39.28-1.91l2.23-2.56-2.89-1.93a.5.5 0 0 0-.55 0L.22 7.752c-.14.09-.22.25-.22.42v1c0 .17.08.32.22.42l11.5 7.67c.08.06.18.08.28.08.1 0 .19-.03.28-.08l11.5-7.67c.14-.09.22-.25.22-.42v-1c0-.17-.08-.32-.22-.42l-.38-.25h-.94c-.24 1.69-1.7 3-3.46 3z"
                :fill="paint"
            />
            <path
                v-if="!upgrade && !paint"
                id="Paintme"
                fill="#2B65D9"
                d="M23.78,7.75L12.28.08c-.17-.11-.39-.11-.55,0L.22,7.75C.08,7.84,0,8,0,8.17v1c0,.17.08.32.22.42l11.5,7.67c.08.06.18.08.28.08s.19-.03.28-.08l11.5-7.67c.14-.09.22-.25.22-.42v-1c0-.17-.08-.32-.22-.42Z"
            />
            <path
                v-if="upgrade && !paint"
                id="Paintme"
                d="M19 10.502c-1.76 0-3.22-1.31-3.46-3h-1.31c-.67 0-1.29-.4-1.57-1.02-.29-.64-.18-1.39.28-1.91l2.23-2.56-2.89-1.93a.5.5 0 0 0-.55 0L.22 7.752c-.14.09-.22.25-.22.42v1c0 .17.08.32.22.42l11.5 7.67c.08.06.18.08.28.08.1 0 .19-.03.28-.08l11.5-7.67c.14-.09.22-.25.22-.42v-1c0-.17-.08-.32-.22-.42l-.38-.25h-.94c-.24 1.69-1.7 3-3.46 3z"
                fill="#2B65D9"
            />
            <path
                id="Shadow"
                d="M23.78,8.58l-11.5,7.67c-.08.06-.18.08-.28.08s-.19-.03-.28-.08L.22,8.58C.08,8.49,0,8.33,0,8.17v1c0,.17.08.32.22.42l11.5,7.67c.08.06.18.08.28.08s.19-.03.28-.08l11.5-7.67c.14-.09.22-.25.22-.42v-1c0,.17-.08.32-.22.42Z"
                fill="#332e2e"
                opacity=".4"
            />
            <path
                v-if="upgrade"
                d="M15.54 7.497h-1.31c-.67 0-1.29-.4-1.57-1.02-.29-.64-.18-1.39.28-1.91l.11-.12-.13-.11c-.53-.45-1.31-.45-1.84 0l-5.4 4.57c-.16.14-.22.36-.15.55.07.19.26.33.47.33h1v3.31l3 2v-3.6c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3.6l3-2v-3.25a3.49 3.49 0 0 1-1.46-2.36v.01zM12 9.997c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                fill="#fff"
            />
            <path
                v-if="!upgrade"
                id="Fixed-symbol"
                d="M10,11.5c0-.28.22-.5.5-.5h3c.28,0,.5.22.5.5v3.6l3-2v-3.31h1c.21,0,.4-.13.47-.33s.01-.42-.15-.55l-1.32-1.12v-1.79c0-.28-.22-.5-.5-.5h-1c-.28,0-.5.22-.5.5v.1l-2.08-1.76c-.53-.45-1.31-.45-1.84,0l-5.4,4.57c-.16.14-.22.36-.15.55s.26.33.47.33h1v3.31l3,2v-3.6ZM12,7c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5-1.5-.67-1.5-1.5.67-1.5,1.5-1.5Z"
                fill="#fff"
            />
            <path
                v-if="upgrade"
                d="M23.93 5.553 19.16.083c-.09-.1-.23-.1-.32 0l-4.77 5.48c-.14.17-.04.45.16.45H17v1c0 1.1.9 2 2 2s2-.9 2-2v-1h2.77c.2 0 .31-.28.16-.45v-.01z"
                fill="#38BD34"
            />
        </g>
    </svg>
</template>

<script setup>
import { useState, stateProps } from '../../composables/useState';
import { usePaint, paintProps } from '../../composables/usePaint';

const props = defineProps({
    ...stateProps(),
    ...paintProps(),
    upgrade: {
        type: Boolean,
        default: false,
    },
    painted: {
        type: Boolean,
        default: false,
    },
});
const { state } = useState(props);
const { paint } = usePaint(props);
</script>
